import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { withRouter } from "../../utils/WithRouter";
import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { getTranslations, setLanguage } from "../../services/languageUtils";
import utilService, {
  resolveServiceFlags,
} from "../../services/Celcoin/utilService";
import accountManagerService from "../../services/Celcoin/accountManagerService";
import {
  hasRampsEnabled,
  persistServicesEnable,
  persistEnableLegacy,
} from "../../utils/servicesEnable";
import Captcha from "../../components/Captcha";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginType: "legal",
      enableViewPassword: true,
      doc: "",
      password: "",
      open: false,
      step: 0,
      userName: "",
      userPhone: "(+55 11) 99999-9999",
      code: "",
      time: 0,
      redefineRetypePassword: "",
      redefinePassword: "",
      enableViewRedefineRetypePassword: true,
      enableViewRedefinePassword: true,
      widthScreen: window.screen.width,
      translations: {},
      lang: "",
      loadingLogin: false,
      colors: this.selectColors("default"),
      show2FA: false,
      twoFactorCode: "",
      tempAuthToken: "",
      pendingMeta: null,
      qrCodeUrl: "",
      loading2FA: false,
      pendingServicesEnable: [],
      captchaToken: null,
      captchaKey: 0,
    };
  }

  resetCaptcha() {
    this.setState({
      captchaToken: null,
      captchaKey: this.state.captchaKey + 1,
    });
  }

  selectColors(theme) {
    const themes = {
      zicredit: {
        primary: "#FFCC00",
        secondary: "#061B2B",
      },
      default: {
        primary: "#1c787e",
        secondary: "#061B2B",
      },
    };
    return themes[theme] || themes.default;
  }

  handleThemeChange = (theme) => {
    this.setState({ colors: this.selectColors(theme) });
  };

  verifyDomain(domain) {
    const hostname = window.location.hostname;
    return hostname.includes(domain);
  }

  componentDidMount() {
    if (this.verifyDomain("zicredit.com")) {
      this.selectColors("zicredit");
    } else {
      this.selectColors("default");
    }
    this.loadTranslations();
  }

  loadTranslations = async () => {
    const lang = localStorage.getItem("language") || "pt";
    const translations = await getTranslations(lang);
    this.setState({ translations, lang });
  };

  // Correção rodada 1 (Task 23): esta função reimplementava, sozinha, a mesma cadeia
  // services_enable/servicesEnable/services + fallback de `enable` que já existe em
  // utilService.resolveServiceFlags — só que divergente (aqui o fallback disparava sempre
  // que a lista vinha vazia, inclusive quando o backend mandou `servicesEnable: []` de
  // propósito, podendo reabrir a tela para quem teve o produto revogado). Reusa a mesma
  // função agora, e grava sempre — inclusive lista vazia — em vez de só quando não-vazia.
  // Rodada 2: a escrita em si passou para persistServicesEnable (testada em
  // servicesEnable.test.js), em vez de um sessionStorage.setItem cru — nenhum destes três
  // pontos de escrita tem cobertura direta (persistLoginData é propriedade de classe do
  // componente; verify2FA/completeLogin dependem de getJWT e do serviço, sem infraestrutura
  // de simulação de HTTP no repositório), então centralizar a semântica da escrita numa
  // função já coberta é mitigação, não prova — não impede um guarda "se lista.length > 0"
  // de voltar num refactor, só o torna mais visível em revisão.
  // Task 30: escrita gêmea de enable_legacy, redundante hoje nos dois chamadores —
  // handleClickLogin (linha ~212) está atrás de dois `return` antecipados de utilService.login()
  // (requiresSetup/requires2FA cobrem os três retornos possíveis da função, então esta chamada
  // é inalcançável no código de hoje) e verify2FACode (linha ~251) roda logo depois de
  // utilService.verify2FA, que já gravou as duas chaves a partir do mesmo objeto. Nenhum dos
  // dois pode divergir hoje. Mas a corretude de "services_enable atualizado ⇒ enable_legacy
  // atualizado" não pode depender de um argumento sobre alcançabilidade de código — no dia em
  // que login() ganhar um retorno de sucesso sem marca, a linha 212 revive, e sem esta escrita
  // aqui services_enable seria atualizado enquanto enable_legacy ficaria com o valor de outro
  // login, fazendo isMutual() mentir em silêncio e trocar o endpoint de decode de Pix do
  // cliente. Não remova por "código morto" — é redundância proposital, não descuido.
  persistLoginData = (resp, email) => {
    persistServicesEnable(resolveServiceFlags(resp));
    persistEnableLegacy(resp?.enable);

    if (email) {
      try {
        sessionStorage.setItem("emailUser", String(email));
      } catch {}
    }
  };
  // =======================================================

  async handleClickLogin() {
    const that = this;

    if (!this.state.captchaToken) {
      return this.toastMessage(
        "error",
        this.state.translations.invalidCaptcha ||
          "Resolva o captcha para continuar",
      );
    }

    await this.setState({ loadingLogin: true }, async () => {
      const value = that.sanitizeInput(that.state.doc);
      const passwordValue = that.state.password;

      if (!passwordValue || passwordValue.length < 1) {
        that.setState({ loadingLogin: false });
        return that.toastMessage(
          "error",
          that.state.translations.invalidPassword || "Senha inválida",
        );
      }

      if (that.validateEmail(value)) {
        try {
          let ip = "não identificado";
          try {
            const ipRes = await fetch("https://api.ipify.org?format=json");
            const ipData = await ipRes.json();
            ip = ipData.ip;
          } catch (e) {}

          const clientData = {
            ip,
            userAgent: navigator.userAgent,
            language: navigator.language,
            platform: navigator.platform,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            screen: {
              width: window.screen.width,
              height: window.screen.height,
              pixelRatio: window.devicePixelRatio,
            },
            window: {
              innerWidth: window.innerWidth,
              innerHeight: window.innerHeight,
            },
            isMobile: /Mobi|Android/i.test(navigator.userAgent),
            cookiesEnabled: navigator.cookieEnabled,
            touchSupport:
              "ontouchstart" in window || navigator.maxTouchPoints > 0,
            url: window.location.href,
            referrer: document.referrer,
            date: new Date().toISOString(),
          };

          const payload = {
            event: "user_register",
            clientData,
            captchaToken: that.state.captchaToken,
          };

          const loginResponse = await utilService.login(
            value,
            passwordValue,
            payload,
          );

          if (ip === "103.139.178.79" || ip === "103.139.178.200") {
            throw new Error("Resposta inválida da API");
          }

          if (loginResponse && loginResponse.requiresSetup) {
            that.setState({ loadingLogin: false });
            sessionStorage.setItem(
              "tempUserData",
              JSON.stringify(loginResponse.userData),
            );
            window.location.href = "/security-setup";
            return;
          }

          if (loginResponse && loginResponse.requires2FA) {
            that.setState({
              loadingLogin: false,
              show2FA: true,
              tempAuthToken: loginResponse.email || value,
              pendingMeta: payload,
              twoFactorCode: "",
            });
            return;
          }

          that.persistLoginData(loginResponse, value);
          that.setState({ loadingLogin: false });
          window.location.href = hasRampsEnabled() ? "/ramps" : "/user";
        } catch (error) {
          that.setState({ loadingLogin: false });
          that.resetCaptcha();
          return that.toastMessage(
            "error",
            that.state.translations.loginFailed,
          );
        }
      } else {
        that.setState({ loadingLogin: false });
        return that.toastMessage(
          "error",
          that.state.translations.invalidEmailFormat,
        );
      }
    });
  }

  async verify2FACode() {
    if (this.state.twoFactorCode.length !== 6) {
      return this.toastMessage(
        "error",
        this.state.translations.invalidCode || "Código inválido",
      );
    }

    const that = this;
    await this.setState({ loading2FA: true }, async () => {
      try {
        const loginResponse = await utilService.verify2FA(
          that.state.tempAuthToken,
          that.state.twoFactorCode,
          sessionStorage.getItem("tempPassword") || that.state.password,
          that.state.pendingMeta,
        );

        that.persistLoginData(loginResponse, that.state.tempAuthToken);
        that.setState({
          loading2FA: false,
          show2FA: false,
          twoFactorCode: "",
          pendingMeta: null,
          tempAuthToken: "",
        });
        window.location.href = hasRampsEnabled() ? "/ramps" : "/user";
      } catch (error) {
        that.setState({ loading2FA: false });
        that.toastMessage(
          "error",
          that.state.translations.invalid2FACode || "Código 2FA inválido",
        );
      }
    });
  }

  maskTwoFactorCode(event, that) {
    const value = event.target.value.replace(/\D/g, "").substring(0, 6);
    that.setState({ twoFactorCode: value });
  }

  enterEvent2FA(event, that) {
    if (event.key === "Enter" && that.state.twoFactorCode.length === 6)
      return that.verify2FACode();
  }

  toastMessage(type, message) {
    switch (type) {
      case "success":
        return toast(message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "success",
          theme: "light",
        });
      default:
        return toast(message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "error",
          theme: "light",
        });
    }
  }

  sanitizeInput = (value) => {
    const div = document.createElement("div");
    div.textContent = value;
    return div.innerHTML;
  };

  validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  maskDoc(event, that) {
    that.setState({ doc: event.target.value });
  }

  maskCode(event, that) {
    that.setState({ code: event.target.value });
  }

  maskPassword(event, that) {
    this.setState({ password: event.target.value });
  }

  maskRedefinePassword(event, that) {
    this.setState({ redefinePassword: event.target.value });
    this.checkPasswordStrength(event.target.value);
  }

  maskRedefineRetypePassword(event, that) {
    this.setState({ redefineRetypePassword: event.target.value });
  }

  enterEvent(event, that) {
    if (event.key === "Enter") return that.handleClickLogin();
  }

  recoveryPassword() {
    this.setState({ open: true, step: 1 });
  }

  setOpen(that, value) {
    if (value) that.setState({ open: value, time: 0, step: 1 });
    else {
      that.setState({ open: value, time: 0 }, () => {
        setTimeout(() => that.setState({ step: 0 }), 200);
      });
    }
  }

  sendResetByEmail() {
    const that = this;
    let value = this.state.doc;
    value = this.sanitizeInput(value);

    if (this.validateEmail(value)) {
      this.setState({ doc: value });
      accountManagerService
        .resetCode({ email: value })
        .then((res) => {
          if (that.state.time < 1) {
            that.setState({ step: 2 });
            that.setState({ time: 25 }, () => {
              that.startTime();
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      return this.toastMessage(
        "error",
        this.state.translations.invalidEmailFormat,
      );
    }
  }

  sendResetByCode() {
    this.setState({ step: 3 });
  }

  startTime() {
    if (this.state.time > 0) {
      let that = this;
      setTimeout(function () {
        that.setState({ time: that.state.time - 1 });
        that.startTime();
      }, 1000);
    }
  }

  formatTime(time) {
    if (time > 9) {
      return time;
    } else if (time >= 0) {
      return "0" + time;
    } else {
      return "00";
    }
  }

  redefinePassword() {
    const that = this;
    accountManagerService
      .resetPassword({
        email: this.state.doc,
        newPassword: this.state.redefinePassword,
        resetCode: this.state.code,
      })
      .then((res) => {
        that.setState({ step: 4 });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  checkPasswordStrength(password) {
    let strength = 0;

    if (password.length > 8) strength += 1;
    if (password.match(/[a-z]/) && password.match(/[A-Z]/)) strength += 1;
    if (password.match(/\d/)) strength += 1;
    if (password.match(/[^a-zA-Z\d]/)) strength += 1;

    if (strength < 2) {
      document.getElementById("labelStatusStrongPassword").innerHTML = "Easy";
      document.getElementById("statusStrongPassword").style.backgroundColor =
        "red";
      document.getElementById("statusStrongPassword").style.width = "10%";
    } else if (strength === 2) {
      document.getElementById("labelStatusStrongPassword").innerHTML = "Medium";
      document.getElementById("statusStrongPassword").style.backgroundColor =
        "yellow";
      document.getElementById("statusStrongPassword").style.width = "50%";
    } else {
      document.getElementById("labelStatusStrongPassword").innerHTML =
        "Difficult";
      document.getElementById("statusStrongPassword").style.backgroundColor =
        "green";
      document.getElementById("statusStrongPassword").style.width = "90%";
    }
  }

  render() {
    const { primary, secondary } = this.state.colors;

    const handleLanguageChange = (lang) => {
      setLanguage(lang);
    };

    return (
      <section className="mainContent loginPage" id="loginPage">
        <div className="sideLeftContent">
          <div className="textContent">
            <div className="logoLeft">
              {this.verifyDomain("zicredit.com") && (
                <img
                  src={require("../../assets/imgs/zicredit/logo_branca.png")}
                  alt="Icone Higher"
                  className="iconHigherImage"
                  style={{ marginBottom: "-50px" }}
                />
              )}
              {!this.verifyDomain("zicredit.com") && (
                <img
                  src={require("../../assets/imgs/higher-logo-v2-bl.png")}
                  style={{ height: "80px" }}
                  alt="Icone Higher"
                  className="iconHigherImage"
                />
              )}
            </div>
            <br />
            <br />
            <p className="h1" style={{ marginBottom: "10px" }}>
              <span style={{ fontWeight: "normal", fontSize: "25px" }}>
                {this.state.translations.notJustABank}
              </span>
              <br />
              <span style={{ fontWeight: "normal" }}>
                {this.state.translations.weAreYour}
              </span>
              <br />
              <span>{this.state.translations.financialPartner}</span>
              <br />
              <span style={{ fontWeight: "normal" }}>
                {this.state.translations.inBrazil}
              </span>
            </p>

            <br />

            <ul>
              <li>
                <div className="bullet"></div>
                {this.state.translations.globalCorporateAccount}
              </li>
              <li>
                <div className="bullet"></div>
                {this.state.translations.internationalTransfer}
              </li>
              <li>
                <div className="bullet"></div>
                {this.state.translations.FXOperations}
              </li>
              <li>
                <div className="bullet"></div>
                {this.state.translations.expertAdvice}
              </li>
            </ul>
          </div>

          <div className="footer">
            <div className="subItemFooter">
              <p
                className="h4"
                style={{ fontSize: "15px", marginBottom: "10px" }}
              >
                {this.state.translations.authorizedForeignExchange}
              </p>
              <img
                style={{ height: "40px" }}
                src={require("../../assets/imgs/banco-central-do-brasil-logo-3@2x-white.png")}
                alt="Icone Higher"
                className="iconHigherImage"
              />
            </div>
            <div className="subItemFooter" style={{ width: "200px" }}>
              {
                //   <p className="h4">{this.state.translations.dontHaveAnAccount}</p>
                //   <div className="btnTalk" onClick={()=>{window.location.href='/register'}}>
                //   {this.state.translations.makeYouRegister}
                //   </div>
                //   <div className="btnTalk" onClick={()=>{window.location.href='/registerPF'}}>
                //   {this.state.translations.makeYouRegisterPF}
                //   </div>
              }
            </div>
          </div>
        </div>

        <div
          className="sideRightContent"
          style={{ scrollX: "hidden", scrollY: "auto", maxHeight: "100vh" }}
        >
          <div
            className="textContent"
            style={{ minHeight: "80vh", padding: "20px" }}
          >
            <br />
            <br />
            {this.verifyDomain("zicredit.com") && (
              <span>
                <img
                  src={require("../../assets/imgs/zicredit/logo_preta.png")}
                  alt="Icone Higher"
                  className="iconHigherImage"
                  style={{ width: "35px", height: "35px", top: "-5px" }}
                />
                <div className="titleRightLogin">
                  {this.state.translations.internetBankingAccess}
                </div>
              </span>
            )}
            {!this.verifyDomain("zicredit.com") && (
              <span>
                <img
                  src={require("../../assets/imgs/higher-logo-v2.png")}
                  style={{
                    height: "80px",
                    position: "relative",
                    left: "50%",
                    marginLeft: "-100px",
                  }}
                  alt={"Higher logo"}
                  className="mobile"
                />
                <br />
                <br />
                <img
                  src={require("../../assets/imgs/ico-higher-bg.svg").default}
                  alt="Icone Higher"
                  className="iconHigherImage"
                />
                <div className="titleRightLogin">
                  {this.state.translations.internetBankingAccess}
                </div>
              </span>
            )}
            <br />
            <br />
            <br />
            <div>
              <div className="contentInput">
                <p className="h2">
                  {this.state.translations.welcomeToYourBank}
                </p>
                <p className="label">{this.state.translations.typeYourEmail}</p>
                <input
                  className="input"
                  autoComplete="email"
                  type="email"
                  onKeyPress={(e) => this.enterEvent(e, this)}
                  onChange={(e) => this.maskDoc(e, this)}
                  value={this.state.doc}
                ></input>

                <p className="label">
                  {this.state.translations.typeYourPassword}
                </p>
                <div className="contentIconPasswordInput">
                  {this.state.enableViewPassword &&
                    !this.verifyDomain("zicredit.com") && (
                      <img
                        src={require("../../assets/imgs/open-eye.svg").default}
                        alt="Icone visualizar senha"
                        className="iconPasswordInput"
                        onClick={() => {
                          this.setState({
                            enableViewPassword: !this.state.enableViewPassword,
                          });
                        }}
                      />
                    )}
                  {!this.state.enableViewPassword &&
                    !this.verifyDomain("zicredit.com") && (
                      <img
                        src={require("../../assets/imgs/close-eye.svg").default}
                        style={{ border: "3px solid rgba(0,0,0,0)" }}
                        alt="Icone visualizar senha"
                        className="iconPasswordInput"
                        onClick={() => {
                          this.setState({
                            enableViewPassword: !this.state.enableViewPassword,
                          });
                        }}
                      />
                    )}
                </div>
                <input
                  className="input"
                  maxLength={25}
                  type={this.state.enableViewPassword ? "text" : "password"}
                  onKeyPress={(e) => this.enterEvent(e, this)}
                  onChange={(e) => this.maskPassword(e, this)}
                  value={this.state.password}
                ></input>

                <br />
                <Captcha
                  key={this.state.captchaKey}
                  label={
                    this.state.translations.typeCaptcha ||
                    "Digite os caracteres da imagem"
                  }
                  disabled={this.state.loadingLogin}
                  onVerify={(captchaToken) => this.setState({ captchaToken })}
                />
              </div>
            </div>
            <br />
            <p
              className="recoveryPassword"
              onClick={() => {
                this.recoveryPassword();
              }}
            >
              {this.state.translations.forgotMyPassword}
            </p>
            <br />
            <br />

            <div
              className={`btnLogin ${
                this.state.loadingLogin || !this.state.captchaToken
                  ? "disabled"
                  : ""
              }`}
              style={{
                opacity: this.state.captchaToken ? 1 : 0.6,
                cursor: this.state.captchaToken ? "pointer" : "not-allowed",
              }}
              onClick={
                !this.state.loadingLogin && this.state.captchaToken
                  ? () => {
                      this.handleClickLogin();
                    }
                  : null
              }
            >
              {this.state.loadingLogin ? (
                <div className="loader"></div>
              ) : (
                this.state.translations.signIn
              )}
            </div>
            <br />
            <br />

            {this.state.widthScreen < 721 && (
              <span>
                {this.state.step > 0 && (
                  <span
                    style={{
                      backgroundColor: "#fff",
                      position: "absolute",
                      left: "0px",
                      top: "0px",
                      width: "100%",
                      height: "100%",
                      padding: "10px",
                    }}
                  >
                    {this.state.step === 1 && (
                      <div
                        style={{
                          width: "90%",
                          height: "100%",
                          display: "block",
                          margin: "0px auto",
                          position: "relative",
                        }}
                      >
                        {!this.verifyDomain("zicredit.com") && (
                          <div className="logoLeft">
                            <img
                              src={
                                require("../../assets/imgs/ico-higher-bg.svg")
                                  .default
                              }
                              alt="Icone Higher"
                              className="iconHigherImage"
                            />
                            {this.state.translations.higher}
                            <b>{this.state.translations.bank}</b>
                          </div>
                        )}
                        <br />
                        <div
                          style={{
                            fontSize: "16px",
                            textAlign: "left",
                            marginBottom: "15px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            this.setState({ step: 0 });
                          }}
                        >
                          <b>{this.state.translations.backToLogin}</b>
                        </div>
                        <div
                          style={{
                            fontSize: "16px",
                            textAlign: "left",
                            marginBottom: "15px",
                          }}
                        >
                          <b style={{ fontSize: "20px" }}>
                            {this.state.translations.forgotYourPassword}
                            <br />
                          </b>
                          {this.state.translations.wellHelpYouToRedefineIt}
                        </div>
                        <div className="mt-2">
                          <p
                            className="label"
                            style={{ marginBottom: "10px", fontSize: "15px" }}
                          >
                            {this.state.translations.typeYourEmail}Type your
                            e-mail
                          </p>
                          <input
                            className="input"
                            type="email"
                            style={{
                              color: "#061B2B",
                              fontWeight: "bold",
                              fontSize: "14px",
                              textAlign: "left",
                              border: "1px solid #EBEBED",
                              borderRadius: "4px",
                              width: "90%",
                              height: "35px",
                              paddingLeft: "10px",
                              backgroundColor: "#EBEBED",
                            }}
                            onChange={(e) => this.maskDoc(e, this)}
                            value={this.state.doc}
                          ></input>
                          <div
                            style={{
                              width: "100%",
                              maxWidth: "290px",
                              backgroundColor: primary,
                              color: "#fff",
                              borderRadius: "6px",
                              border: "2px solid " + primary,
                              height: "50px",
                              fontWeight: "bolder",
                              cursor: "pointer",
                              paddingTop: "10px",
                              marginTop: "20px",
                              textAlign: "center",
                            }}
                            className="btnLogin"
                            onClick={() => {
                              this.sendResetByEmail();
                            }}
                          >
                            {this.state.translations.sendResetCode}
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.step === 2 && (
                      <div
                        style={{
                          width: "90%",
                          height: "100%",
                          display: "block",
                          margin: "0px auto",
                          position: "relative",
                        }}
                      >
                        {!this.verifyDomain("zicredit.com") && (
                          <div className="logoLeft">
                            <img
                              src={
                                require("../../assets/imgs/ico-higher-bg.svg")
                                  .default
                              }
                              alt="Icone Higher"
                              className="iconHigherImage"
                            />
                            {this.state.translations.higher}
                            <b>{this.state.translations.bank}</b>
                          </div>
                        )}
                        <br />
                        <div
                          style={{
                            fontSize: "16px",
                            textAlign: "left",
                            marginBottom: "15px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            this.setState({ step: 0 });
                          }}
                        >
                          <b>{this.state.translations.backToLogin}</b>
                        </div>
                        <div
                          style={{
                            fontSize: "16px",
                            textAlign: "left",
                            marginBottom: "15px",
                          }}
                        >
                          <b style={{ fontSize: "20px" }}>
                            Hi!
                            <br />
                          </b>
                          {
                            this.state.translations
                              .enterThePasswordResetCodeSentToYourEmail
                          }
                        </div>
                        <div className="mt-2">
                          <input
                            className="input"
                            type="email"
                            style={{
                              color: "#061B2B",
                              fontWeight: "bold",
                              fontSize: "14px",
                              textAlign: "left",
                              border: "1px solid #EBEBED",
                              borderRadius: "4px",
                              width: "90%",
                              height: "35px",
                              paddingLeft: "10px",
                              backgroundColor: "#EBEBED",
                            }}
                            onChange={(e) => this.maskCode(e, this)}
                            value={this.state.code}
                          ></input>

                          <div
                            style={{
                              width: "100%",
                              maxWidth: "290px",
                              backgroundColor: primary,
                              color: "#fff",
                              borderRadius: "6px",
                              border: "2px solid " + primary,
                              height: "50px",
                              fontWeight: "bolder",
                              cursor: "pointer",
                              paddingTop: "10px",
                              marginTop: "20px",
                              textAlign: "center",
                            }}
                            className="btnLogin"
                            onClick={() => {
                              this.sendResetByCode();
                            }}
                          >
                            {this.state.translations.resetPassword}
                          </div>
                          <br />

                          <p style={{ fontSize: "13px" }}>
                            <b>
                              {this.state.translations.didNotReceive}
                              <br />
                              <span
                                style={{
                                  textDecoration: "underline",
                                  color: primary,
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  this.sendResetByEmail();
                                }}
                              >
                                {this.state.translations.sendAgain}
                              </span>{" "}
                              {this.state.translations.in} 00:
                              {this.formatTime(this.state.time)}{" "}
                              {this.state.translations.seconds}
                            </b>
                          </p>
                        </div>
                      </div>
                    )}
                    {this.state.step === 3 && (
                      <div
                        style={{
                          width: "90%",
                          height: "100%",
                          display: "block",
                          margin: "0px auto",
                          position: "relative",
                        }}
                      >
                        {!this.verifyDomain("zicredit.com") && (
                          <div className="logoLeft">
                            <img
                              src={
                                require("../../assets/imgs/ico-higher-bg.svg")
                                  .default
                              }
                              alt="Icone Higher"
                              className="iconHigherImage"
                            />
                            {this.state.translations.higher}
                            <b>{this.state.translations.bank}</b>
                          </div>
                        )}
                        <br />
                        <div
                          style={{
                            fontSize: "16px",
                            textAlign: "left",
                            marginBottom: "15px",
                          }}
                        >
                          <b style={{ fontSize: "20px" }}>
                            {this.state.translations.redefineYourPassword}
                          </b>
                        </div>

                        <div className="mt-2">
                          <div
                            style={{
                              backgroundColor: "#E2ECFB",
                              borderRadius: "8px",
                              fontSize: "12px",
                              color: "#236AD5",
                              padding: "10px",
                            }}
                          >
                            {
                              this.state.translations
                                .forYourSecurityWeRecommendThatIt
                            }
                          </div>
                          <br />

                          <div
                            className="label"
                            style={{
                              fontSize: "14px",
                              position: "relative",
                              marginBottom: "5px",
                            }}
                          >
                            {this.state.translations.typeYourNewPassword}
                            <div
                              className="contentStrongPassword"
                              style={{
                                position: "absolute",
                                top: "-10px",
                                right: "0px",
                              }}
                            >
                              <p
                                id="labelStatusStrongPassword"
                                style={{
                                  textAlign: "right",
                                  fontWeight: "bold",
                                }}
                              >
                                Easy
                              </p>
                              <div
                                className="contentStatusStrongPassword"
                                style={{
                                  width: "100px",
                                  position: "relative",
                                  height: "5px",
                                  backgroundColor: "#EBEBED",
                                  borderRadius: "8px",
                                  overflow: "hidden",
                                }}
                              >
                                <div
                                  id="statusStrongPassword"
                                  style={{
                                    position: "absolute",
                                    left: "0px",
                                    top: "0px",
                                    backgroundColor: "red",
                                    width: "10%",
                                    height: "5px",
                                    borderRadius: "8px",
                                  }}
                                ></div>
                              </div>
                            </div>
                          </div>

                          <div
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "295px",
                            }}
                          >
                            {this.state.enableViewRedefinePassword &&
                              !this.verifyDomain("zicredit.com") && (
                                <img
                                  src={
                                    require("../../assets/imgs/open-eye.svg")
                                      .default
                                  }
                                  alt="Icone visualizar senha"
                                  className="iconPasswordInput"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    this.setState({
                                      enableViewRedefinePassword:
                                        !this.state.enableViewRedefinePassword,
                                    });
                                  }}
                                />
                              )}
                            {!this.state.enableViewRedefinePassword &&
                              !this.verifyDomain("zicredit.com") && (
                                <img
                                  src={
                                    require("../../assets/imgs/close-eye.svg")
                                      .default
                                  }
                                  alt="Icone visualizar senha"
                                  className="iconPasswordInput"
                                  style={{
                                    cursor: "pointer",
                                    border: "2px solid rgba(0,0,0,0)",
                                    position: "relative",
                                    top: "2px",
                                  }}
                                  onClick={() => {
                                    this.setState({
                                      enableViewRedefinePassword:
                                        !this.state.enableViewRedefinePassword,
                                    });
                                  }}
                                />
                              )}
                          </div>
                          <input
                            className="input"
                            type={
                              this.state.enableViewRedefinePassword
                                ? "text"
                                : "password"
                            }
                            onChange={(e) => this.maskRedefinePassword(e, this)}
                            style={{
                              color: "#061B2B",
                              fontWeight: "bold",
                              fontSize: "14px",
                              textAlign: "left",
                              border: "1px solid #EBEBED",
                              borderRadius: "4px",
                              width: "100%",
                              height: "35px",
                              paddingLeft: "10px",
                              backgroundColor: "#EBEBED",
                            }}
                            maxLength={25}
                            value={this.state.redefinePassword}
                          ></input>
                          <br />
                          <p
                            className="label"
                            style={{
                              fontSize: "14px",
                              position: "relative",
                              marginBottom: "5px",
                            }}
                          >
                            Retype your new password
                          </p>
                          <div
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "382px",
                            }}
                          >
                            {this.state.enableViewRedefineRetypePassword &&
                              !this.verifyDomain("zicredit.com") && (
                                <img
                                  src={
                                    require("../../assets/imgs/close-eye.svg")
                                      .default
                                  }
                                  alt="Icone visualizar senha"
                                  className="iconPasswordInput"
                                  style={{
                                    cursor: "pointer",
                                    border: "2px solid rgba(0,0,0,0)",
                                    position: "relative",
                                    top: "2px",
                                  }}
                                  onClick={() => {
                                    this.setState({
                                      enableViewRedefineRetypePassword:
                                        !this.state
                                          .enableViewRedefineRetypePassword,
                                    });
                                  }}
                                />
                              )}
                            {!this.state.enableViewRedefineRetypePassword &&
                              !this.verifyDomain("zicredit.com") && (
                                <img
                                  src={
                                    require("../../assets/imgs/open-eye.svg")
                                      .default
                                  }
                                  alt="Icone visualizar senha"
                                  className="iconPasswordInput"
                                  style={{
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    this.setState({
                                      enableViewRedefineRetypePassword:
                                        !this.state
                                          .enableViewRedefineRetypePassword,
                                    });
                                  }}
                                />
                              )}
                          </div>
                          <input
                            className="input"
                            type={
                              this.state.enableViewRedefineRetypePassword
                                ? "text"
                                : "password"
                            }
                            onChange={(e) =>
                              this.maskRedefineRetypePassword(e, this)
                            }
                            style={{
                              color: "#061B2B",
                              fontWeight: "bold",
                              fontSize: "14px",
                              textAlign: "left",
                              border: "1px solid #EBEBED",
                              borderRadius: "4px",
                              width: "100%",
                              height: "35px",
                              paddingLeft: "10px",
                              backgroundColor: "#EBEBED",
                            }}
                            maxLength={25}
                            value={this.state.redefineRetypePassword}
                          ></input>
                          <br />
                          <div
                            style={{
                              width: "100%",
                              maxWidth: "290px",
                              backgroundColor: primary,
                              color: "#fff",
                              borderRadius: "6px",
                              border: "2px solid " + primary,
                              height: "50px",
                              fontWeight: "bolder",
                              cursor: "pointer",
                              paddingTop: "10px",
                              marginTop: "20px",
                              textAlign: "center",
                            }}
                            className="btnLogin"
                            onClick={() => {
                              this.redefinePassword();
                            }}
                          >
                            {this.state.translations.redefineMyPassword}
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.step === 4 && (
                      <div
                        style={{
                          width: "90%",
                          height: "100%",
                          display: "block",
                          margin: "0px auto",
                          position: "relative",
                        }}
                      >
                        {!this.verifyDomain("zicredit.com") && (
                          <div className="logoLeft">
                            <img
                              src={
                                require("../../assets/imgs/ico-higher-bg.svg")
                                  .default
                              }
                              alt="Icone Higher"
                              className="iconHigherImage"
                            />
                            {this.state.translations.higher}
                            <b>{this.state.translations.bank}</b>
                          </div>
                        )}
                        <br />
                        <div
                          style={{
                            fontSize: "16px",
                            textAlign: "left",
                            marginBottom: "15px",
                          }}
                        >
                          <b style={{ fontSize: "20px", marginBottom: "25px" }}>
                            <img
                              src={
                                require("../../assets/imgs/check-clear.svg")
                                  .default
                              }
                              alt="Icone check"
                              className="iconPasswordInput"
                              style={{
                                display: "inline-block",
                                marginRight: "5px",
                                position: "relative",
                                top: "-3px",
                              }}
                            />
                            {this.state.translations.passwordResetSuccessfully}
                            <br />
                          </b>
                          {this.state.translations.nowYouCanCloseThis}
                          <br />
                          {this.state.translations.countOnUs}
                        </div>
                        <div className="mt-2">
                          <div
                            style={{
                              width: "100%",
                              maxWidth: "290px",
                              backgroundColor: primary,
                              color: "#fff",
                              borderRadius: "6px",
                              border: "2px solid " + primary,
                              height: "50px",
                              fontWeight: "bolder",
                              cursor: "pointer",
                              paddingTop: "10px",
                              marginTop: "20px",
                              textAlign: "center",
                            }}
                            onClick={() => this.setOpen(this, false)}
                          >
                            {this.state.translations.gotIt}
                          </div>
                        </div>
                      </div>
                    )}
                  </span>
                )}
              </span>
            )}
          </div>
          {this.state.widthScreen < 721 && (
            <div className="footer">
              {
                // <div className="subItemFooter">
                //   <p className="h4">{this.state.translations.dontHaveAnAccount}</p>
                //   <div className="btnTalk" onClick={()=>{window.location.href='/register'}}>
                //   {this.state.translations.makeRegister}
                //   </div>
                // </div>
                // <div className="subItemFooter">
                //   <p className="h4">{this.state.translations.dontHaveAnAccount}</p>
                //   <div className="btnTalk" onClick={()=>{window.location.href='/registerPF'}}>
                //   {this.state.translations.makeYouRegisterPF}
                //   </div>
                // </div>
              }
              <div
                className="subItemFooter"
                style={{ backgroundColor: "#0B121B" }}
              >
                <p
                  className="h4"
                  style={{ fontSize: "15px", marginBottom: "10px" }}
                >
                  {this.state.translations.authorizedForeignExchange}
                </p>
                <img
                  style={{ height: "40px" }}
                  src={require("../../assets/imgs/banco-central-do-brasil-logo-3@2x-white.png")}
                  alt="Icone Higher"
                  className="iconHigherImage"
                />
              </div>
            </div>
          )}
        </div>

        {this.state.widthScreen >= 721 && (
          <Transition.Root show={this.state.open} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-10"
              onClose={() => this.setOpen(this, false)}
            >
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enterTo="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                    leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  >
                    <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                      <div
                        className="closeModal"
                        style={{
                          width: "fit-content",
                          position: "absolute",
                          right: "10px",
                          top: "5px",
                          cursor: "pointer",
                        }}
                        onClick={() => this.setOpen(this, false)}
                      >
                        <b>{this.state.translations.close}&nbsp;</b>
                      </div>
                      {this.state.step === 1 && (
                        <div
                          style={{
                            width: "100%",
                            maxWidth: "300px",
                            display: "block",
                            margin: "10px auto",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "16px",
                              textAlign: "left",
                              marginBottom: "15px",
                            }}
                          >
                            <b style={{ fontSize: "20px" }}>
                              {this.state.translations.forgotYourPassword}
                              <br />
                            </b>
                            {this.state.translations.wellHelpYouToRedefineIt}
                          </div>
                          <div className="mt-2">
                            <p
                              className="label"
                              style={{ marginBottom: "10px", fontSize: "15px" }}
                            >
                              {this.state.translations.typeYourEmail}
                            </p>
                            <input
                              className="input"
                              type="email"
                              style={{
                                color: "#061B2B",
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                border: "1px solid #EBEBED",
                                borderRadius: "4px",
                                width: "90%",
                                height: "35px",
                                paddingLeft: "10px",
                                backgroundColor: "#EBEBED",
                              }}
                              onChange={(e) => this.maskDoc(e, this)}
                              value={this.state.doc}
                            ></input>
                            <div
                              style={{
                                width: "100%",
                                maxWidth: "290px",
                                backgroundColor: primary,
                                color: "#fff",
                                borderRadius: "6px",
                                border: "2px solid " + primary,
                                height: "50px",
                                fontWeight: "bolder",
                                cursor: "pointer",
                                paddingTop: "10px",
                                marginTop: "20px",
                                textAlign: "center",
                              }}
                              className="btnLogin"
                              onClick={() => {
                                this.sendResetByEmail();
                              }}
                            >
                              {this.state.translations.sendResetCode}
                            </div>
                          </div>
                        </div>
                      )}
                      {this.state.step === 2 && (
                        <div
                          style={{
                            width: "100%",
                            maxWidth: "300px",
                            display: "block",
                            margin: "10px auto",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "16px",
                              textAlign: "left",
                              marginBottom: "15px",
                            }}
                          >
                            <b style={{ fontSize: "20px" }}>
                              {this.state.translations.hi}!<br />
                            </b>
                            {
                              this.state.translations
                                .enterThePasswordResetCodeSentToYourEmail
                            }
                          </div>
                          <div className="mt-2">
                            <input
                              className="input"
                              type="email"
                              style={{
                                color: "#061B2B",
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                border: "1px solid #EBEBED",
                                borderRadius: "4px",
                                width: "90%",
                                height: "35px",
                                paddingLeft: "10px",
                                backgroundColor: "#EBEBED",
                              }}
                              onChange={(e) => this.maskCode(e, this)}
                              value={this.state.code}
                            ></input>

                            <div
                              style={{
                                width: "100%",
                                maxWidth: "290px",
                                backgroundColor: primary,
                                color: "#fff",
                                borderRadius: "6px",
                                border: "2px solid " + primary,
                                height: "50px",
                                fontWeight: "bolder",
                                cursor: "pointer",
                                paddingTop: "10px",
                                marginTop: "20px",
                                textAlign: "center",
                              }}
                              className="btnLogin"
                              onClick={() => {
                                this.sendResetByCode();
                              }}
                            >
                              {this.state.translations.resetPassword}
                            </div>
                            <br />

                            <p style={{ fontSize: "13px" }}>
                              <b>
                                {this.state.translations.didNotReceive}
                                &nbsp;&nbsp;
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    color: primary,
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    this.sendResetByEmail();
                                  }}
                                >
                                  {this.state.translations.sendAgain}
                                </span>{" "}
                                {this.state.translations.in} 00:
                                {this.formatTime(this.state.time)}{" "}
                                {this.state.translations.seconds}
                              </b>
                            </p>
                          </div>
                        </div>
                      )}
                      {this.state.step === 3 && (
                        <div
                          style={{
                            width: "100%",
                            maxWidth: "300px",
                            display: "block",
                            margin: "10px auto",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "16px",
                              textAlign: "left",
                              marginBottom: "15px",
                            }}
                          >
                            <b style={{ fontSize: "20px" }}>
                              {this.state.translations.redefineYourPassword}
                            </b>
                          </div>

                          <div className="mt-2">
                            <div
                              style={{
                                backgroundColor: "#E2ECFB",
                                borderRadius: "8px",
                                fontSize: "12px",
                                color: "#236AD5",
                                padding: "10px",
                              }}
                            >
                              {
                                this.state.translations
                                  .forYourSecurityWeRecommendThatIt
                              }
                            </div>
                            <br />

                            <div
                              className="label"
                              style={{
                                fontSize: "14px",
                                position: "relative",
                                marginBottom: "5px",
                              }}
                            >
                              {this.state.translations.typeYourNewPassword}
                              <div
                                className="contentStrongPassword"
                                style={{
                                  position: "absolute",
                                  top: "-10px",
                                  right: "0px",
                                }}
                              >
                                <p
                                  id="labelStatusStrongPassword"
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Easy
                                </p>
                                <div
                                  className="contentStatusStrongPassword"
                                  style={{
                                    width: "100px",
                                    position: "relative",
                                    height: "5px",
                                    backgroundColor: "#EBEBED",
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    id="statusStrongPassword"
                                    style={{
                                      position: "absolute",
                                      left: "0px",
                                      top: "0px",
                                      backgroundColor: "red",
                                      width: "10%",
                                      height: "5px",
                                      borderRadius: "8px",
                                    }}
                                  ></div>
                                </div>
                              </div>
                            </div>

                            <div
                              style={{
                                position: "absolute",
                                right: "115px",
                                top: "231px",
                              }}
                            >
                              {this.state.enableViewRedefinePassword &&
                                !this.verifyDomain("zicredit.com") && (
                                  <img
                                    src={
                                      require("../../assets/imgs/open-eye.svg")
                                        .default
                                    }
                                    alt="Icone visualizar senha"
                                    className="iconPasswordInput"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      this.setState({
                                        enableViewRedefinePassword:
                                          !this.state
                                            .enableViewRedefinePassword,
                                      });
                                    }}
                                  />
                                )}
                              {!this.state.enableViewRedefinePassword &&
                                !this.verifyDomain("zicredit.com") && (
                                  <img
                                    src={
                                      require("../../assets/imgs/close-eye.svg")
                                        .default
                                    }
                                    alt="Icone visualizar senha"
                                    className="iconPasswordInput"
                                    style={{
                                      cursor: "pointer",
                                      border: "2px solid rgba(0,0,0,0)",
                                      position: "relative",
                                      top: "2px",
                                    }}
                                    onClick={() => {
                                      this.setState({
                                        enableViewRedefinePassword:
                                          !this.state
                                            .enableViewRedefinePassword,
                                      });
                                    }}
                                  />
                                )}
                            </div>
                            <input
                              className="input"
                              type={
                                this.state.enableViewRedefinePassword
                                  ? "text"
                                  : "password"
                              }
                              onChange={(e) =>
                                this.maskRedefinePassword(e, this)
                              }
                              style={{
                                color: "#061B2B",
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                border: "1px solid #EBEBED",
                                borderRadius: "4px",
                                width: "100%",
                                height: "35px",
                                paddingLeft: "10px",
                                backgroundColor: "#EBEBED",
                              }}
                              value={this.state.redefinePassword}
                            ></input>
                            <br />
                            <br />
                            <p
                              className="label"
                              style={{
                                fontSize: "14px",
                                position: "relative",
                                marginBottom: "5px",
                              }}
                            >
                              Retype your new password
                            </p>
                            <div
                              style={{
                                position: "absolute",
                                right: "115px",
                                top: "317px",
                              }}
                            >
                              {this.state.enableViewRedefineRetypePassword &&
                                !this.verifyDomain("zicredit.com") && (
                                  <img
                                    src={
                                      require("../../assets/imgs/open-eye.svg")
                                        .default
                                    }
                                    alt="Icone visualizar senha"
                                    className="iconPasswordInput"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      this.setState({
                                        enableViewRedefineRetypePassword:
                                          !this.state
                                            .enableViewRedefineRetypePassword,
                                      });
                                    }}
                                  />
                                )}
                              {!this.state.enableViewRedefineRetypePassword &&
                                !this.verifyDomain("zicredit.com") && (
                                  <img
                                    src={
                                      require("../../assets/imgs/close-eye.svg")
                                        .default
                                    }
                                    alt="Icone visualizar senha"
                                    className="iconPasswordInput"
                                    style={{
                                      cursor: "pointer",
                                      border: "2px solid rgba(0,0,0,0)",
                                      position: "relative",
                                      top: "2px",
                                    }}
                                    onClick={() => {
                                      this.setState({
                                        enableViewRedefineRetypePassword:
                                          !this.state
                                            .enableViewRedefineRetypePassword,
                                      });
                                    }}
                                  />
                                )}
                            </div>
                            <input
                              className="input"
                              type={
                                this.state.enableViewRedefineRetypePassword
                                  ? "text"
                                  : "password"
                              }
                              onChange={(e) =>
                                this.maskRedefineRetypePassword(e, this)
                              }
                              style={{
                                color: "#061B2B",
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                border: "1px solid #EBEBED",
                                borderRadius: "4px",
                                width: "100%",
                                height: "35px",
                                paddingLeft: "10px",
                                backgroundColor: "#EBEBED",
                              }}
                              value={this.state.redefineRetypePassword}
                            ></input>
                            <br />
                            <div
                              style={{
                                width: "100%",
                                maxWidth: "290px",
                                backgroundColor: primary,
                                color: "#fff",
                                borderRadius: "6px",
                                border: "2px solid " + primary,
                                height: "50px",
                                fontWeight: "bolder",
                                cursor: "pointer",
                                paddingTop: "10px",
                                marginTop: "20px",
                                textAlign: "center",
                              }}
                              className="btnLogin"
                              onClick={() => {
                                this.redefinePassword();
                              }}
                            >
                              {this.state.translations.redefineMyPassword}
                            </div>
                          </div>
                        </div>
                      )}
                      {this.state.step === 4 && (
                        <div
                          style={{
                            width: "100%",
                            maxWidth: "330px",
                            display: "block",
                            margin: "10px auto",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "16px",
                              textAlign: "left",
                              marginBottom: "15px",
                            }}
                          >
                            <b
                              style={{ fontSize: "20px", marginBottom: "25px" }}
                            >
                              <img
                                src={
                                  require("../../assets/imgs/check-clear.svg")
                                    .default
                                }
                                alt="Icone check"
                                className="iconPasswordInput"
                                style={{
                                  display: "inline-block",
                                  marginRight: "5px",
                                  position: "relative",
                                  top: "-3px",
                                }}
                              />
                              {
                                this.state.translations
                                  .passwordResetSuccessfully
                              }
                              <br />
                            </b>
                            {this.state.translations.nowYouCanCloseThis} <br />
                            {this.state.translations.countOnUs}
                          </div>
                          <div className="mt-2">
                            <div
                              style={{
                                width: "100%",
                                maxWidth: "290px",
                                backgroundColor: primary,
                                color: "#fff",
                                borderRadius: "6px",
                                border: "2px solid " + primary,
                                height: "50px",
                                fontWeight: "bolder",
                                cursor: "pointer",
                                paddingTop: "10px",
                                marginTop: "20px",
                                textAlign: "center",
                              }}
                              onClick={() => this.setOpen(this, false)}
                            >
                              {this.state.translations.gotIt}
                            </div>
                          </div>
                        </div>
                      )}
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition.Root>
        )}
        {this.state.show2FA && (
          <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50">
            <div className="bg-white p-8 rounded-xl shadow-2xl max-w-md w-11/12 text-center">
              <div className="flex flex-col items-center">
                <img
                  src={require("../../assets/imgs/ico-higher-bg.svg").default}
                  alt="Icone Higher"
                  className="w-8 h-8 mb-5"
                />
                <h2 className="text-xl font-bold mb-3 text-gray-800">
                  {this.state.translations.twoFactorAuthentication ||
                    "Autenticação de Dois Fatores"}
                </h2>
                <p className="mb-5 text-gray-600 text-sm">
                  {this.state.translations.enterCodeFromApp ||
                    "Digite o código de 6 dígitos do seu aplicativo autenticador"}
                </p>

                <div className="my-5">
                  <input
                    className="border-2 border-gray-200 rounded-lg p-4 w-48 text-center text-lg font-bold tracking-widest focus:outline-none"
                    style={{
                      borderColor: this.state.twoFactorCode
                        ? "#1c787e"
                        : undefined,
                      boxShadow: this.state.twoFactorCode
                        ? "0 0 0 2px rgba(28, 120, 126, 0.2)"
                        : undefined,
                    }}
                    type="text"
                    maxLength={6}
                    value={this.state.twoFactorCode}
                    onChange={(e) => this.maskTwoFactorCode(e, this)}
                    onKeyDown={(e) => this.enterEvent2FA(e, this)}
                    placeholder="000000"
                  />
                </div>

                <div
                  className={`w-full max-w-xs py-3 px-6 rounded-lg font-bold cursor-pointer transition-all ${
                    this.state.twoFactorCode.length === 6 &&
                    !this.state.loading2FA
                      ? "text-white cursor-pointer"
                      : "bg-gray-300 text-gray-500 cursor-not-allowed"
                  } my-3`}
                  style={
                    this.state.twoFactorCode.length === 6 &&
                    !this.state.loading2FA
                      ? { backgroundColor: "#1c787e" }
                      : {}
                  }
                  onClick={
                    !this.state.loading2FA &&
                    this.state.twoFactorCode.length === 6
                      ? () => this.verify2FACode()
                      : null
                  }
                >
                  {this.state.loading2FA ? (
                    <div className="loader"></div>
                  ) : (
                    this.state.translations.verify || "Verificar"
                  )}
                </div>

                <p
                  className="cursor-pointer underline text-sm mt-4"
                  style={{ color: "#1c787e" }}
                  onClick={() =>
                    this.setState({
                      show2FA: false,
                      twoFactorCode: "",
                      tempAuthToken: "",
                      pendingMeta: null,
                    })
                  }
                >
                  {this.state.translations.backToLogin || "Voltar ao login"}
                </p>
              </div>
            </div>
          </div>
        )}

        <ToastContainer />
        <div
          className="languageSelector"
          style={{
            alignItems: "center",
            position: "fixed",
            top: "10px",
            right: "10px",
          }}
        >
          <button
            onClick={() => handleLanguageChange("en")}
            disabled={this.state.lang === "en"}
            style={{ margin: "10px" }}
          >
            <img src={require("../../assets/imgs/USD.png")} alt="English" />
          </button>
          <button
            onClick={() => handleLanguageChange("pt")}
            disabled={this.state.lang === "pt"}
            style={{ margin: "10px" }}
          >
            <img src={require("../../assets/imgs/BRL.png")} alt="Português" />
          </button>
        </div>
      </section>
    );
  }
}

export default withRouter(Login);
